import _ from 'lodash';
import * as elementActionTypes from '../actions/previewElementActions';
import update from 'react-addons-update';
import { getElementList } from '../helpers/elementListHelpers';
import {getFixedBorderStyle} from '../helpers/elementBorderHelpers';
import { getViewState } from '../helpers/elementViewHelpers';
import { isChildElement } from 'crazyEditor/core/elements/utils/elementFilterUtils';
import { getParentIdFromChildId } from 'crazyEditor/redux/modules/element/helpers/elementChildrenHelpers';

export default function reducer(state = {}, action = {}) {
  let elementToUpdate;
  let elementId;
  let elementList;
  let viewState;

  switch (action.type) {
    case elementActionTypes.SET_ELEMENT_UPDATE_PREVIEW:
      viewState = getViewState();
      elementId = _.isArray(action.ids) ? action.ids[0] : action.ids;
      const parentId = getParentIdFromChildId(elementId);
      if (parentId) {
        elementId = parentId;
      }
      elementList = getElementList(elementId);
      elementToUpdate = state[viewState][elementList][elementId];
      let elementsPreviews;
      if (parentId) {
        elementsPreviews = [{id: elementId, data: {childrenProps: action.elementProps}}];
      } else {
        elementsPreviews = [{id: elementId, ...getFixedBorderStyle(elementToUpdate, action.elementProps)}];
      }
      return update(state, {
        preview: {
          $set: elementsPreviews
        }
      });
    case elementActionTypes.CLEAR_ELEMENT_UPDATE_PREVIEW:
      return update(state, {
        preview: {
          $set: null
        }
      });
    case elementActionTypes.APPLY_ELEMENT_UPDATE_PREVIEW:
      if (_.isNil(state.preview)) {
        return state;
      }
      viewState = getViewState();
      elementId = state.preview[0].id;
      elementList = getElementList(elementId);
      const stateUpdate = {
        [viewState]: {
          [elementList]: {}
        },
        preview: {
          $set: null
        }
      };
      state.preview.forEach((preview) => {
        const element = state[viewState][elementList][preview.id];
        stateUpdate[viewState][elementList][element.id] = {
          $set: _.merge({}, element, preview)
        };
      });
      return update(state, stateUpdate);
    default:
      return state;
  }
}
